var permissionsListenerInit = false;
export var onNotificationsPermissionChange = cb => {
  document.addEventListener("notification-permission-changed", cb);
};
/**
 * Add an event listener which emits the event "notification-permission-changed" when the user changes the state of the notifications
 * */
export var addPermissionStateListener = () => {
  if (!navigator.permissions || !navigator.permissions.query) return;
  //setting the listener ONCE
  !permissionsListenerInit && navigator.permissions.query({
    name: "notifications"
  }).then(function (permission) {
    // Initial status is available at permission.state
    permission.onchange = function () {
      // Whenever there's a change, updated status is available at this.state
      document.dispatchEvent(new CustomEvent("notification-permission-changed", {
        detail: {
          permissionState: this.state
        }
      }));
    };
  });
  permissionsListenerInit = true;
};